import CreateDeviceMake from "./CreateDeviceMake";
import { useConfirm } from "material-ui-confirm";
import confirmDialogStyleOptions from "../../../../../common/helpers/confirmDialogParams";
import StyledDialog from "../../../../../common/components/dialog/StyledDialog";

interface CreateDeviceMakesDialogProps {
  open: boolean;
  handleClose: () => void;
}

const CreateDeviceMakesDialog = ({
  open,
  handleClose,
}: CreateDeviceMakesDialogProps): JSX.Element => {
  const confirm = useConfirm();
  const confirmDialogClose = (): void => {
    confirm({
      title: "Are you sure you want to cancel?",
      confirmationText: "Cancel",
      cancellationText: "Back",
      ...confirmDialogStyleOptions,
      confirmationButtonProps: {
        ...confirmDialogStyleOptions.confirmationButtonProps,
        color: "primary",
      },
    })
      .then(async (): Promise<void> => {
        handleClose();
      })
      .catch(() => {
        // User clicked "Back" - do nothing, keep dialog open
      });
  };

  return (
    <StyledDialog
      open={open}
      title="Create Device Make"
      onClose={confirmDialogClose}
      maxWidth="md"
      showSubmitButton={false}
    >
      <CreateDeviceMake onSuccess={handleClose} />
    </StyledDialog>
  );
};

export default CreateDeviceMakesDialog;
